import React, { FC } from 'react';
import { Path } from './styles';

const Candy: FC<SVGIconProps> = ({ color }) => (
  <svg width="63" height="63" viewBox="0 0 63 63" fill="none">
    <Path
      d="M40.7925 22.2075C45.9375 27.3525 45.9375 35.6475 40.7925 40.7925C35.6475 45.9375 27.3525 45.9375 22.2338 40.7925C17.115 35.6475 17.0625 27.3525 22.2338 22.2075C27.405 17.0625 35.6475 17.0625 40.7925 22.2075ZM51.1088 11.9438C51.1088 11.9438 48.5625 12.2588 45.7538 14.07C45.36 11.34 44.0475 8.58379 41.8163 6.35254C38.535 9.60754 38.1413 13.7025 38.9288 16.6425C42.5775 17.5875 45.4125 20.4225 46.3575 24.0713C49.2975 24.8588 53.3925 24.465 56.6475 21.1838C54.4425 18.9788 51.7388 17.6925 49.035 17.2725C50.0588 15.75 50.8725 13.9913 51.1088 11.9438ZM11.8913 51.0563C11.8913 51.0563 14.4375 50.7413 17.2463 48.93C17.64 51.66 18.9525 54.4163 21.1838 56.6475C24.465 53.3925 24.8588 49.2975 24.0713 46.3575C20.4225 45.4125 17.5875 42.5775 16.6425 38.9288C13.7025 38.1413 9.60754 38.535 6.35254 41.8163C8.55754 44.0213 11.2613 45.3338 13.965 45.7275C12.9413 47.25 12.1275 49.035 11.8913 51.0563Z"
      fillColor={color}
    />
  </svg>
);

export default Candy;
